import entries from './help-tool-entries.json';
export interface HelpStudioEntry {
  id: string;
  title: string;
  screen: string;
  options: Record<string, string | boolean>;
}
const key = 'steos:help:studio-entry';
const targets: Record<string, Omit<HelpStudioEntry, 'id'>> = entries;
/** Разрешены только конкретные входы из проверенного реестра инструкций. */
export function helpStudioTarget(id: string): HelpStudioEntry | null {
  return Object.hasOwn(targets, id) ? { ...targets[id], id } : null;
}
export function saveHelpStudioTarget(entry: HelpStudioEntry) {
  sessionStorage.setItem(key, JSON.stringify({ id: entry.id }));
  sessionStorage.removeItem('steos:history:repeat');
  sessionStorage.removeItem('steos:studio:profile-entry');
}
export function peekHelpStudioTarget() {
  try {
    const raw = JSON.parse(sessionStorage.getItem(key) || 'null');
    return raw && typeof raw.id === 'string' ? helpStudioTarget(raw.id) : null;
  } catch {
    return null;
  }
}
export function readHelpStudioTarget(expected?: HelpStudioEntry) {
  const entry = peekHelpStudioTarget();
  if (expected && entry?.id !== expected.id) return null;
  try {
    sessionStorage.removeItem(key);
  } catch {
    /* Сохраняем работу текущего перехода без хранилища. */
  }
  return entry;
}
